import { cn } from '@/lib/utils';
import { DebugStep, DebugStepType } from '@/shared/types/tryIt';

import { AuthStep } from './AuthStep';
import { BrainStep } from './BrainStep';
import { ContextChanges } from './ContextChanges';

import styles from '../DetailsSection.module.scss';

interface BrainStepsProps {
  steps: DebugStep[];
}

export const BrainSteps = ({ steps }: BrainStepsProps) => {
  return (
    <>
      {steps?.map((step, index) => {
        const isAuth = step?.type === DebugStepType.AUTH;
        return (
          // eslint-disable-next-line react/no-array-index-key
          <div className={styles.step} key={`${JSON.stringify(step)}-${index}`}>
            <div className={styles.title}>
              {isAuth ? <AuthStep step={step} /> : <BrainStep step={step} />}
            </div>

            {!isAuth && step && step?.action_type === 'webhook' && step?.sub_steps?.length > 0 && (
              <div className={cn(styles.details, styles.webhookDetails)}>
                {step?.context_changes && (
                  <ContextChanges context_changes={step.context_changes} isSubsteps />
                )}
                <BrainSteps steps={step.sub_steps} />
              </div>
            )}

            <div className={styles.details}></div>
          </div>
        );
      })}
    </>
  );
};
